module.exports = __webpack_public_path__ + "img/personnel_access_feature_03.28828a60.jpg";